import * as React from "react";
const SvgUsdt = (props) => (
  <svg
    width={36}
    height={36}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx={18} cy={18} r={18} fill="#fff" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 36C8.058 36 0 27.942 0 18S8.058 0 18 0s18 8.058 18 18-8.058 18-18 18Zm2.162-20.483v-2.662h6.091V8.796H9.669v4.06h6.091v2.66c-4.95.227-8.672 1.208-8.672 2.383 0 1.174 3.722 2.154 8.672 2.383v8.53h4.402v-8.533c4.942-.227 8.656-1.207 8.656-2.38 0-1.174-3.714-2.154-8.656-2.382Zm0 4.039v-.002c-.123.009-.761.047-2.184.047-1.137 0-1.937-.034-2.218-.047v.003c-4.374-.192-7.639-.954-7.639-1.865 0-.91 3.265-1.672 7.64-1.868V18.8c.285.02 1.104.068 2.236.068 1.358 0 2.038-.056 2.165-.067v-2.974c4.365.195 7.622.957 7.622 1.866 0 .911-3.257 1.67-7.622 1.864Z"
      fill="#6BCBA2"
    />
  </svg>
);
export default SvgUsdt;
